import { CwtApiEntity, CwtModel, CwtProp } from "@cawita/core-front/api";
import { FileDictionary } from "./file-dictionary.model";

@CwtModel({ name: 'settings' })
export class Settings extends CwtApiEntity {
    @CwtProp({ ref: FileDictionary }) privacyPolicy: FileDictionary;
    @CwtProp({ ref: FileDictionary }) termsOfUse: FileDictionary;
}